import React from 'react';
import InfoCard from './InfoCard';
import CommissionTransferCard from './CommissionTransferCard'

const Details = ({ status, destinationBankAccount, transfer }) => {
    const {
       account,
       accountDigit,
       accountType,
       agency,
       agencyDigit,
       bankCode,
       cpfCnpj,
       name
     } = destinationBankAccount

    return (
        <div className="row">
            <div className='col'>
                <InfoCard
                    status={status}
                    account={account}
                    accountDigit={accountDigit}
                    agency={agency}
                    agencyDigit={agencyDigit}
                    bankCode={bankCode}
                    cpfCnpj={cpfCnpj}
                    name={name}
                />
                <CommissionTransferCard
                    transfer={transfer}
                />
            </div>
        </div>
    )
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Details/Details/index.js